// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"728821bd","706":"8003f062","783":"611c4c9b","890":"47a56a31","943":"fab8a67e","956":"f2d4a890","981":"a435c0d1"}[chunkId] + ".chunk.js";
};